import styled from 'styled-components';

const StyledSubHeader = styled.nav`
  display: flex;
  padding: 0.6rem;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 2px 3px;
  z-index: 1;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.primary.main} !important;
  height: 8vh
`;


export { StyledSubHeader };
